import axios from "axios";
import { toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("sidi_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Statuts de passerelle indiquant un serveur en cours de réveil / indisponible brièvement.
const RETRY_STATUSES = [502, 503, 504];
const MAX_RETRIES = 4;
let wakeToast = null;

const clearWake = () => { if (wakeToast !== null) { toast.dismiss(wakeToast); wakeToast = null; } };

api.interceptors.response.use(
  (r) => { clearWake(); return r; },
  async (err) => {
    const status = err?.response?.status;
    if (status === 401) {
      localStorage.removeItem("sidi_token");
      localStorage.removeItem("sidi_user");
      clearWake();
      return Promise.reject(err);
    }
    const cfg = err.config || {};
    const isNetwork = !err.response; // pas de réponse = serveur endormi / coupé
    const retriable = isNetwork || RETRY_STATUSES.includes(status);
    if (retriable && !cfg.__skipRetry) {
      cfg.__retryCount = (cfg.__retryCount || 0) + 1;
      if (cfg.__retryCount <= MAX_RETRIES) {
        if (wakeToast === null) wakeToast = toast.loading("Connexion en cours…");
        await new Promise((res) => setTimeout(res, Math.min(800 * cfg.__retryCount, 3000)));
        return api(cfg);
      }
    }
    clearWake();
    return Promise.reject(err);
  }
);
